import { addScript } from "../../bundles/helpers/add-script";
(async ($) => {
	if (!window.Mark) await addScript(PUBLIC_PATH + 'vendor/mark.vendor.js');
  const CLASSES = {
    BLOCK: 'brands-filter',
    ACTIVE: 'brands-filter_active',
    INPUT: 'brands-filter__search',
    SUBMIT: 'brands-filter__submit',
    ITEM: 'brands-filter__item',
    FORM: 'brands-filter__form',
    EMPTY: 'brands-filter__empty',
    WRAPPER: 'brands-filter__wrapper',
    LETTER: 'brands-filter_letter',
    BODY: 'brands-filter__body',
    FEEDBACK: 'brands-filter__feedback',
  };

  const SELECTORS = {
    RESULTS: '[data-results]',
  };

  class BrandsFilter {
    constructor(block) {
      this.block = block;
      this.input = this.block.getElementsByClassName(CLASSES.INPUT).item(0);
      this.body = this.block.getElementsByClassName(CLASSES.BODY).item(0);
      this.submit = this.block.getElementsByClassName(CLASSES.SUBMIT).item(0);
      this.resultsContainer = this.block.querySelector(SELECTORS.RESULTS);
      this.feedback = this.block.getElementsByClassName(CLASSES.FEEDBACK).item(0);
      this.list = [...this.block.getElementsByClassName(CLASSES.ITEM)];
      this.form = this.block.getElementsByClassName(CLASSES.FORM).item(0);
      this.emptyText = this.block.getElementsByClassName(CLASSES.EMPTY).item(0);
      this.wrappers = Array.from(this.block.getElementsByClassName(CLASSES.WRAPPER));
      this.filteredItemsCounter = 0;

      this.init = this.init.bind(this);
      this.clickHandler = this.clickHandler.bind(this);
      this.doSearch = this.doSearch.bind(this);
      this.inputUpdate = this.inputUpdate.bind(this);
      this.submitHandler = this.submitHandler.bind(this);

      this.init();
    }

    init() {
      this.markInstance = new Mark(this.resultsContainer);
      this.block.addEventListener('click', this.clickHandler);
      this.input.addEventListener('input', this.inputUpdate);
      this.form.addEventListener('submit', this.submitHandler);
    }

    inputUpdate() {
      if (this.input.value.length > 0) this.submit.classList.add(`${CLASSES.SUBMIT}_active`);
      else this.submit.classList.remove(`${CLASSES.SUBMIT}_active`);
    }

    submitHandler(event) {
      event.preventDefault();
      if (!this.input.value) return;
      if (this.input.value && this.input.value.length < 3) {
        this.toggleInvalidFeedback(true);
      }
      if (this.input.value !== '' && this.input.value.length >= 3) {
        this.toggleInvalidFeedback(false);
        this.clearWrappers();
        this.clearResultsContainer();
        const text = this.input.value;
        this.doSearch(text);
        this.markSearchQueryInText(text);
      }
    }

    toggleInvalidFeedback(isShown) {
      isShown ? this.feedback.classList.remove('d-none') : this.feedback.classList.add('d-none');
    }

    clickHandler(event) {
      if (event.target.hasAttribute('data-action')) {
        event.preventDefault();
        this.getSearchValue(event.target);
      }
    }

    getSearchValue(item) {
      let letter = '';
      switch (item.dataset.action) {
        case 'clear':
          this.clear();
          this.clearWrappers();
          break;
        case 'letter':
          this.clear();
          letter = item.textContent;
          this.input.value = letter;
          this.inputUpdate();
          this.clearWrappers();
          this.filterWrappers(letter);
          break;
        default:
      }
    }

    clearWrappers() {
      const activeWrapper = this.body.querySelector('.' + CLASSES.WRAPPER + '.d-block');
      activeWrapper && activeWrapper.classList.remove('d-block');
      this.block.classList.remove(CLASSES.LETTER);
    }

    clear() {
      this.toggleInvalidFeedback(false);
      this.block.classList.remove(CLASSES.BLOCK + '_active');
      this.input.value = '';
      this.inputUpdate();
      this.hideEmpty();
    }

    clearResultsContainer() {
      [...this.resultsContainer.children].forEach((item) => {
        this.resultsContainer.removeChild(item);
      });
    }

    filterWrappers(letter) {
      let count = 0;
      this.wrappers.forEach((item) => {
        if (letter.toLowerCase() === item.getAttribute('data-list-wrapper').toLowerCase()) {
          item.classList.add('d-block');
          count++;
        }
      });
      if (!count) {
        this.showEmpty();
      } else {
        this.hideEmpty();
      }
      this.block.classList.add(CLASSES.LETTER);
    }

    doSearch(text) {
      this.filteredItemsCounter = 0;
      this.block.classList.add(CLASSES.BLOCK + '_active');
      this.filterListOfItems(text);
      if (this.filteredItemsCounter) {
        this.hideEmpty();
      } else this.showEmpty();
    }

    appendFilteredItem(item) {
      this.resultsContainer.append(item.cloneNode(true));
    }

    markSearchQueryInText(text) {
      this.markInstance.unmark({
        done: () => {
          this.markInstance.mark(text, {'element': 'span', 'className': 'brands-filter__mark'});
        },
      });
    }

    showEmpty() {
      this.emptyText.classList.add(CLASSES.EMPTY + '_active');
    }

    hideEmpty() {
      this.emptyText.classList.remove(CLASSES.EMPTY + '_active');
    }

    filterListOfItems(value) {
      const reg = new RegExp(value, 'i');
      this.list.forEach((item) => {
        if (reg.test(item.textContent)) {
          this.filteredItemsCounter++;
          this.appendFilteredItem(item);
        }
      });
    }
  }

  const init = function() {
    $('.brands-filter').each((index, item)=> {
      var brandsFilter = new BrandsFilter(item);
      $(item).data('brands-filter', brandsFilter);
    });
  };
  init();
})($);
